import React, { FC, memo, useCallback } from 'react';
import { Select } from 'AurionCR/components/form/select';
import { IDataGridFilter } from 'components/data-grid/model';
import style from './index.module.scss';
import renderColoredIconOption from 'components/select-render-components/render-colored-icon-option';
import renderColoredIconTags from 'components/select-render-components/render-colored-icon-tags';
import { calcFilterSelectResult } from 'components/data-grid/components/filters/filter-select';
import { useFiltersSheetSettings } from 'components/filters-dialog/context';
import { ColoredOptionIcon } from 'components/select-render-components/helpers';

/**
 * SC-06: AurionCR's Select hands renderOption to MUI's Autocomplete as is, and MUI
 * calls it (props, option, state) and expects the <li> back. renderColoredIconOption
 * has the v4 (option) signature -- AppSelect adapts it for its own callers -- so
 * here, unadapted, it read `Icon` off the <li> props and the list crashed on open
 * (React #130). The same adapter as AppSelect's.
 */
const renderOption = (
  { key, ...props }: React.HTMLAttributes<HTMLLIElement> & { key?: React.Key },
  option: ColoredOptionIcon,
) => (
  <li key={key} {...props}>
    {renderColoredIconOption(option)}
  </li>
);

const FilterSelectWithColoredIcon: FC<
  React.PropsWithChildren<{
    filter: IDataGridFilter;
    value: any;
    onTasks: any;
  }>
> = ({ filter, value, onTasks }) => {
  const onChange = useCallback((e: any, value: any) => {
    onTasks([
      ['pagination', { page: 1 }],
      // @ts-ignore
      ['filters', { [filter.field]: calcFilterSelectResult(value, filter.options.option.value) }],
      ['getData'],
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // N2 (T5, DC-18 a): "all" as the placeholder in the filters sheet
  const settings = useFiltersSheetSettings(filter.options);
  return (
    <Select
      multiple
      value={value}
      onChange={onChange}
      renderOption={renderOption}
      renderValue={renderColoredIconTags}
      className={style.root}
      settings={settings}
      style={filter.options?.style}
    />
  );
};

export default memo(FilterSelectWithColoredIcon);
